/**
 * Validates that price_model array items have required fields
 * Checks that each price model has amount, currency, and type
 *
 * @param {object} errors - The errors object to populate
 * @param {any} value - The field value (price_model array)
 * @param {object} item - The full item being edited
 * @param {object} validatorParams - Parameters for the validator
 * @param {object} field - The field definition
 */
export default function priceModelValidator(errors, value, item, validatorParams, field) {
  // If no value or empty array, let the required validator handle it
  if (!value || !Array.isArray(value) || value.length === 0) {
    return
  }

  // Check each price model item
  for (let i = 0; i < value.length; i++) {
    const priceItem = value[i]

    // Skip if item is null/undefined
    if (!priceItem) continue

    // Check for required fields
    const missingFields = []

    if (!priceItem.amount && priceItem.amount !== 0) {
      missingFields.push('amount')
    }

    if (!priceItem.currency || (typeof priceItem.currency === 'string' && !priceItem.currency.trim())) {
      missingFields.push('currency')
    }

    if (!priceItem.type || (typeof priceItem.type === 'string' && !priceItem.type.trim())) {
      missingFields.push('type')
    }

    // If any required fields are missing, set error
    if (missingFields.length > 0) {
      errors[field.id] = `Please add a regular price with amount, currency, and type`
      return
    }
  }
}
